/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Week_Tag_DietInputs */

const en_portal_week_tag_diet = /** @type {(inputs: Portal_Week_Tag_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diet`)
};

const pl_portal_week_tag_diet = /** @type {(inputs: Portal_Week_Tag_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieta`)
};

/**
* | output |
* | --- |
* | "Diet" |
*
* @param {Portal_Week_Tag_DietInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_week_tag_diet = /** @type {((inputs?: Portal_Week_Tag_DietInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Week_Tag_DietInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_week_tag_diet(inputs)
	return en_portal_week_tag_diet(inputs)
});